module.exports = __webpack_public_path__ + "static/img/exp_three.28db35fc.png";